/**
 * OKS-857 — Single source of truth for the brand SPLASH image aspect ratio.
 *
 * The brand splash overlay (invite landing + brand-switch arrival) used the
 * landscape `cover_image` (3:2 after OKS-855) as its full-bleed background,
 * which crops to a thin center band on a tall phone screen. OKS-857 adds a
 * dedicated PORTRAIT 9:16 splash image, cropped-on-upload to that ratio via
 * the shared `CoverCropper` and displayed full-bleed behind the splash
 * lockup. The ratio lives HERE, once — mirroring `lib/brand-cover.ts` /
 * `lib/mission-cover.ts` — so a future ratio change is a single edit and no
 * surface can silently drift.
 *
 * Two shapes are exported because two consumers need different forms:
 *
 *   - `SPLASH_COVER_ASPECT_CLASS` — the Tailwind utility class string
 *     consumed by the 9:16 preview band (`BrandSplashCoverBand`) and the
 *     crop viewport. It MUST remain a literal `"aspect-[9/16]"` string in
 *     THIS file: Tailwind v4's JIT scans source for arbitrary-value
 *     utilities, so the literal has to exist somewhere it can see it.
 *     Keeping it here (and only here) is what makes the "one edit point"
 *     guarantee real — do not build it dynamically.
 *
 *   - `SPLASH_COVER_ASPECT_RATIO` — the numeric ratio (width / height =
 *     9 / 16 = 0.5625) fed to `react-easy-crop`'s `aspect` prop and the
 *     crop-area math via the shared `CoverCropper`. Kept in lockstep with
 *     the class.
 */

/**
 * Tailwind aspect-ratio utility for the brand-splash portrait preview +
 * crop viewport. Literal string (see module note) — do not build it
 * dynamically.
 */
export const SPLASH_COVER_ASPECT_CLASS = "aspect-[9/16]"

/**
 * Numeric brand-splash ratio (width / height = 9 / 16 = 0.5625). Feeds the
 * shared `CoverCropper` `react-easy-crop` `aspect` and the canvas crop-area
 * math.
 */
export const SPLASH_COVER_ASPECT_RATIO = 9 / 16
